module.exports = __webpack_public_path__ + "img/product-preview-18.332d4a7.png";